import { UserPermissions } from '@centecomm/portal-service';
import React from 'react';
import { FeatureConfiguration } from '../../Core/Types/FeatureConfiguration';
import InspectionsNavigationIcon from '../../Icons/NavigationItem/Inspections';
import { LoadingContent } from '../../Shared/PageElements/LoadingContent';

const LazyLeftHeaderComponent = React.lazy(() => import('./Application/LeftHeaderComponent'));
const LazyPage = React.lazy(() => import('./Application/Pages/Page'));
const LazyInspectionsPage = React.lazy(() => import('./Pages/InspectionsPage'));

const inspectionsConfiguration: FeatureConfiguration = {
    name: 'Inspections',
    application: {
        url: '/app/inspections',
        PageRoot: (
            <React.Suspense fallback={<LoadingContent />}>
                <LazyPage />
            </React.Suspense>
        ),
        LeftHeaderComponent: (
            <React.Suspense fallback={<LoadingContent />}>
                <LazyLeftHeaderComponent />
            </React.Suspense>
        ),
        permissions: [UserPermissions.CreateInspection],
    },
    navigationItem: {
        route: {
            text: 'common:sidebar.featureInspectionsTitle',
            url: '/inspections',
            Icon: InspectionsNavigationIcon,
            ownerOperatorRoot: (
                <React.Suspense fallback={<LoadingContent />}>
                    <LazyInspectionsPage />
                </React.Suspense>
            ),
            tenantRoot: null,
        },
        permissions: [UserPermissions.ViewInspection],
    },
    disableFeature: [],
    checkIfEnabledViaSettings: (settings) => {
        if (settings && settings.inspection) {
            return settings.inspection.visible;
        }

        return false;
    },
};

export default inspectionsConfiguration;
